// Generated by OrchestKit Claude Plugin
// Created: 2026-09-12

import type { ReactNode } from 'react';
import { Montant } from '../../composants/ui/index.ts';
import { DESTINATIONS, type Destination, type LigneRetournable } from './types.ts';

/**
 * Choix des articles rendus — Q-042.
 *
 * Chaque ligne porte sa destination : rayon ou rebut. Le choix est par
 * ARTICLE, pas par retour, parce qu'un même client rend souvent une pièce
 * intacte et une pièce abîmée dans le même geste.
 */
export function LignesRetour({
  lignes,
  quantites,
  destinations,
  onQuantite,
  onDestination,
}: {
  lignes: LigneRetournable[];
  quantites: Record<string, string>;
  destinations: Record<string, Destination>;
  onQuantite: (ligneId: string, valeur: string) => void;
  onDestination: (ligneId: string, valeur: Destination) => void;
}): ReactNode {
  if (lignes.length === 0) {
    return <p>Tout a déjà été repris sur cette vente.</p>;
  }

  return (
    <div className="tableau-defilant">
      <table>
        <thead>
          <tr>
            <th>Produit</th>
            <th>Reprenable</th>
            <th>Prix unitaire</th>
            <th>Quantité rendue</th>
            <th>Destination</th>
          </tr>
        </thead>
        <tbody>
          {lignes.map((ligne) => {
            const saisie = quantites[ligne.vente_ligne_id] ?? '';
            const excessive = Number(saisie === '' ? '0' : saisie) > ligne.quantite_retournable;

            return (
              <tr key={ligne.vente_ligne_id}>
                <td>{ligne.designation}</td>
                <td>
                  {ligne.quantite_retournable} / {ligne.quantite_vendue}
                </td>
                <td>
                  <Montant valeur={ligne.prix_unitaire_net} />
                </td>
                <td>
                  <input
                    aria-label={`Quantité rendue — ${ligne.designation}`}
                    inputMode="numeric"
                    size={4}
                    value={saisie}
                    onChange={(evenement) => {
                      onQuantite(ligne.vente_ligne_id, evenement.target.value.replace(/\D/g, ''));
                    }}
                  />
                  {/* Dit AVANT l'envoi ce que le serveur refuserait après. */}
                  {excessive && <span> au-delà du reprenable</span>}
                </td>
                <td>
                  <select
                    aria-label={`Destination — ${ligne.designation}`}
                    value={destinations[ligne.vente_ligne_id] ?? 'STOCK'}
                    onChange={(evenement) => {
                      onDestination(ligne.vente_ligne_id, evenement.target.value as Destination);
                    }}
                  >
                    {Object.entries(DESTINATIONS).map(([code, libelle]) => (
                      <option key={code} value={code}>
                        {libelle}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
